import { gql } from '@apollo/client';

export const ACCOUNT_STATEMENT_REMOVED = gql`
  subscription accountStatementDeleted {
    accountStatementDeleted {
      configId
    }
  }
`;
